// extracted by mini-css-extract-plugin
export default {"btn":"BlueBtn_btn__ADsFI","spaceadder":"BlueBtn_spaceadder__OHBeW","containonbtn":"BlueBtn_containonbtn__p3oNO"};